import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['row', 'selectAll', 'seeMoreBtn', 'seeMoreContainer', 'noResults'];
  static values = {
    pageSize: { type: Number, default: 40 },
    totalRows: { type: Number, default: 0 },
  };

  visibleCount = 0;
  isSearching = false;

  connect() {
    this.visibleCount = this.pageSizeValue;
    this.updateRowVisibility();

    if (this.hasSeeMoreBtnTarget) {
      this.seeMoreBtnTarget.addEventListener('click', this.handleSeeMore.bind(this));
    }

    const searchInput = document.querySelector('input[name="search"]');
    if (searchInput) {
      searchInput.addEventListener('input', () => {
        this.updateRowVisibility();
      });
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.addEventListener('change', this.handleSelectAll.bind(this));
    }

    this.rowTargets.forEach((row) => {
      const checkbox = row.querySelector('.user-email-checkbox');
      if (checkbox) {
        checkbox.addEventListener('change', () => {
          this.updateSelectAllState();
        });
      }
    });
  }

  getVisibleCheckboxes() {
    return this.rowTargets
      .filter((row) => row.style.display !== 'none')
      .map((row) => row.querySelector('.user-email-checkbox'))
      .filter((cb) => cb !== null);
  }

  updateSelectAllState() {
    if (!this.hasSelectAllTarget) return;

    const visibleCheckboxes = this.getVisibleCheckboxes();
    if (visibleCheckboxes.length === 0) {
      this.selectAllTarget.checked = false;
      this.selectAllTarget.indeterminate = false;
      return;
    }

    const checkedCount = visibleCheckboxes.filter((cb) => cb.checked).length;

    if (checkedCount === 0) {
      this.selectAllTarget.checked = false;
      this.selectAllTarget.indeterminate = false;
    } else if (checkedCount === visibleCheckboxes.length) {
      this.selectAllTarget.checked = true;
      this.selectAllTarget.indeterminate = false;
    } else {
      this.selectAllTarget.checked = false;
      this.selectAllTarget.indeterminate = true;
    }
  }

  handleSelectAll() {
    if (!this.hasSelectAllTarget) return;

    const visibleCheckboxes = this.getVisibleCheckboxes();
    const shouldCheck = this.selectAllTarget.checked;

    visibleCheckboxes.forEach((cb) => {
      cb.checked = shouldCheck;
    });
  }

  updateRowVisibility() {
    const searchInput = document.querySelector('input[name="search"]');
    const searchValue = searchInput ? searchInput.value.toLowerCase().trim() : '';

    this.isSearching = searchValue.length > 0;
    let totalMatchCount = 0;

    this.rowTargets.forEach((row, index) => {
      const searchable = row.getAttribute('data-searchable') || '';
      const matchesSearch = searchValue === '' || searchable.indexOf(searchValue) !== -1;

      if (matchesSearch) {
        totalMatchCount++;
        if (this.isSearching || index < this.visibleCount) {
          row.style.display = '';
        } else {
          row.style.display = 'none';
        }
      } else {
        row.style.display = 'none';
      }
    });

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.style.display = totalMatchCount === 0 && searchValue !== '' ? '' : 'none';
    }

    if (this.hasSeeMoreContainerTarget) {
      if (this.isSearching || this.visibleCount >= this.totalRowsValue) {
        this.seeMoreContainerTarget.style.display = 'none';
      } else {
        this.seeMoreContainerTarget.style.display = '';
        const remaining = this.totalRowsValue - this.visibleCount;
        if (this.hasSeeMoreBtnTarget) {
          this.seeMoreBtnTarget.textContent = 'See More (' + remaining + ' remaining)';
        }
      }
    }

    this.updateSelectAllState();
  }

  handleSeeMore() {
    this.visibleCount += this.pageSizeValue;
    this.updateRowVisibility();
  }
}
